<template>
  <div class="product-data">
    <Header/>
    <div class="content">
      <div class="left">
        <p>{{ $t('satellite.SatelliteData') }}</p>
        <div class="menu-site" @click="changeMenu(i)" v-for="i in menuList" :key="i.index">
          <div class="biaoqian center">
            <span v-if="i.pkid==activeMenu" class="iconfont icon-weixing2 sate-ac"></span>
            <span v-else class="iconfont icon-weixing2 sate-unac"></span>
          </div>
          <span
              :style="{'color':(i.pkid==activeMenu?'rgba(38,125,255,1)':'')}">{{ i.typeName }} ({{ i.typeNum }})</span>
        </div>
      </div>
      <div class="right">
        <div class="label-query">
          <span>{{ $t('satellite.CurrentPosition') }}：<span @click="$router.push('/')"
                                                            style="cursor: pointer">{{ $t('satellite.Home') }}</span> / {{
              $t('satellite.SatelliteData')
            }}</span>
          <el-input :placeholder="$t('satellite.placeholder')" v-model="query.productName" size="mini"
                    class="input-with-select query-input" @keyup.enter.native="getProductListFunc" clearable>
            <el-button @click="getProductListFunc" slot="append" icon="el-icon-search"></el-button>
          </el-input>
        </div>
        <div class="key-words">
          <span :style="{width:isEnglish?'125px':'80px'}">{{ $t('satellite.ProductTypes') }}：</span>
          <div class="key-word-box">
            <span :class="query.productTypeList.length==0?'key-word-site-ac':'key-word-site'"
                  @click="allKey">{{ $t('satellite.All') }}</span>
            <span :class="query.productTypeList.includes(i.productTypeId)?'key-word-site-ac':'key-word-site'"
                  @click="siteProductClass(i)" v-for="i in productClass" :key="i.index">{{ i.typeName }}</span>
          </div>
        </div>
        <hr>
        <div class="key-words">
          <span :style="{width:isEnglish?'125px':'80px'}">{{ $t('satellite.Sensor') }}：</span>
          <div class="key-word-box" style="flex:1;">
            <span :class="query.sensorIdList.length==0?'key-word-site-ac':'key-word-site'"
                  @click="allKeySensor">{{ $t('satellite.All') }}</span>
            <span :class="query.sensorIdList.includes(i.pkid)?'key-word-site-ac':'key-word-site'" @click="sitekey(i)"
                  v-for="i in keywords" :key="i.index">{{ i.sensorName }}</span>
          </div>
        </div>
        <div class="product-box">
          <div class="product-site" v-for="i in productList" :key="i.index">
            <el-image
                @click="goDetail(i)"
                style="width: 360px; height: 200px;border: 0px"
                :src="mediaDown+i.mediaUrl"
            ></el-image>
            <p class="product-site-title">
              <span class="product-site-title-name">{{ i.productAlias }}</span>
              <span class="product-site-title-free">{{ i.isFree ? $t('satellite.Free') : $t('satellite.Free') }}</span>
            </p>
            <p class="product-site-user">{{ $t('satellite.Scenes') }}：{{ i.dataNum }}</p>
            <div class="product-site-detail">
              <div class="product-site-detail-left">
                <p class="product-site-detail-left-num">
                  {{ $t('satellite.DataVolume') }}：{{ byte2Auto(i.spaceUsage) }}</p>
                <p class="product-site-detail-other">{{ $t('satellite.Views') }}：{{ i.dataGlanced }}</p>
              </div>
              <div class="product-site-detail-right center" @click="goDetail(i)">{{ $t('satellite.Details') }}</div>
            </div>
          </div>
          <div class="product-site-transparent" v-for="i in (productList.length!=0?4-productList.length%4:0)"
               :key="i.index"></div>
        </div>
        <div class="pagenations">
          <el-pagination
              background
              :page-size="query.limit"
              :current-page="query.page"
              @current-change="currentChange"
              layout="prev, pager, next"
              :total="total">
          </el-pagination>
        </div>
      </div>
    </div>
    <Footer/>
  </div>
</template>

<script>
import Header from "@/components/Header"
import Footer from "@/components/Footer"
import {
  getSatelliteClass,
  getSensorByClassId,
  getSatelliteList
} from "@/api/satellite/index"

export default {
  name: 'product-data',
  components: {
    Header,
    Footer
  },
  data() {
    return {
      activeMenu: 0,
      query: {
        page: 1,
        limit: 9,
        satelliteTypeId: '',
        sensorIdList: [],
        productTypeList: [],
        productName: ''
      },
      total: 0,
      menuList: [],
      productClass: [],
      keywords: [],
      productList: [],
      isEnglish: false
    }
  },
  watch: {
    '$route.query.typeId'(val) {
      this.query.sensorIdList = []
      this.query.productTypeList = []
      this.query.page = 1
      this.query.satelliteTypeId = val

      this.activeMenu = val
      this.getTopic(val)
    }
  },
  methods: {
    allKey() {
      this.query.productTypeList = []
      this.getProductListFunc()
    },
    allKeySensor() {
      this.query.sensorIdList = []
      this.getProductListFunc()
    },
    sitekey(val) {
      if (this.query.sensorIdList.includes(val.pkid)) {
        this.query.sensorIdList.splice(this.query.sensorIdList.findIndex(item => item === val.pkid), 1)
      } else {
        this.query.sensorIdList.push(val.pkid)
      }
      this.getProductListFunc()
    },
    siteProductClass(val) {
      if (this.query.productTypeList.includes(val.productTypeId)) {
        const index = this.query.productTypeList.findIndex(item => item === val.productTypeId)
        this.query.productTypeList.splice(index, 1)
      } else {
        this.query.productTypeList.push(val.productTypeId)
      }
      this.getProductListFunc()
    },
    changeMenu(item) {
      this.$router.push({
        query: {
          typeId: item.pkid,
        },
      });
    },
    currentChange(val) {
      this.query.page = val
      this.getProductListFunc()
      this.$router.push({
            query: {
              typeId: this.$route.query.typeId,
              page: val
            }
          }
      )
    },
    goDetail(val) {
      this.$router.push({
        path: '/satellite/satelliteInfo', query: {
          sateInfo: val.pkid
        }
      })
    },
    async getProductMenuList() {
      let that = this
      let {data} = await getSatelliteClass()
      let res = data
      this.menuList = res
      let findPkid
      if (that.activeMenu === 0) {
        findPkid = res[0]
        this.activeMenu = findPkid.pkid
      } else {

        findPkid = res.find(item => item.pkid === that.activeMenu)
      }
      this.query.satelliteTypeId = findPkid.pkid
      this.getTopic(this.query.satelliteTypeId)
    },
    async getTopic(val) {
      let {data} = await getSensorByClassId({typeId: val})
      let res = data
      this.productClass = res.productTypeList

      this.keywords = res.sensorList
      this.getProductListFunc()
    },
    async getProductListFunc() {
      let params = JSON.parse(JSON.stringify(this.query))
      params.sensorIdList = params.sensorIdList.join(',')
      params.productTypeList = params.productTypeList.join(',')
      let {data} = await getSatelliteList(params)
      let res = data
      this.productList = res.list
      this.total = parseFloat(res.totalCount)
      console.log(res);
    }
  },
  created() {
    const lastPage = this.$route.query.page ? this.$route.query.page : 1
    if (lastPage) {
      this.query.page = parseInt(lastPage)
    }
    this.activeMenu = this.$route.query.typeId ? this.$route.query.typeId : 0
    this.getProductMenuList()
  },
  mounted() {
    const language = window.localStorage.getItem('language')
    if (language === 'zh') {
      this.isEnglish = false
    }
    if (language === 'en') {
      this.isEnglish = true
    }
  },
}
</script>

<style lang="scss" scoped>
.product-data {
  width: 100%;
  min-height: 700px;
  @include product_bg_color();

  .content {
    display: flex;
    height: 100%;
    width: 1551px;
    margin: 0 auto;
    padding-top: 14px;

    .left {
      width: 216px;
      height: calc(100% - 24px);
      @include product_wenzi_color();
      padding: 24px 0 0 24px;

      .menu-site {
        display: flex;
        align-items: center;
        height: 36px;
        width: 100%;
        margin: 12px 0;
        cursor: pointer;
        font-size: 14px;

        .biaoqian {
          width: 24px;
          height: 24px;
          margin: 0 15px 0 0;

          .icon-weixing2 {
            font-size: 24px;
          }

          .sate-ac {
            color: #3390F8;
          }

          .sate-unac {
            @include product_icon_weixing();
          }
        }
      }
    }

    .right {
      flex: 1;
      height: 100%;
      @include product_bg_color();
      @include co_white_to_black();
      margin-left: 12px;

      .label-query {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 0 36px;
        height: 60px;
        margin-bottom: 8px;
        @include product_bg_r2_color();

        .query-input {
          width: 360px;
        }
      }

      hr {
        width: calc(100% - 24 * 2px);
        margin-left: 24px;
        @include product_hr_v1_color();
      }

      .key-words {
        padding: 0 36px;
        display: flex;
        align-items: center;

        @include product_bg_r1_color();

        .key-word-box {
          margin: 12px 0;

          .key-word-site-ac {
            margin: 0 24px;
            line-height: 36px;
            background-color: rgba(38, 125, 255, 1);
            padding: 4px;
            color: white;
            cursor: default;
          }

          .key-word-site {
            margin: 0 24px;
            line-height: 36px;
            background-color: rgba(38, 125, 255, 0);
            padding: 4px;
            cursor: pointer;
          }
        }
      }

      .query-time {
        padding: 12px 36px;
        @include product_bg_r1_color();
      }

      .product-box {
        @include product_bg_r1_color();
        padding: 24px 36px 0 36px;
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        min-height: 451px;

        .product-site {
          width: 360px;
          margin-bottom: 24px;

          img {
            width: 360px;
            height: 200px;
          }

          &-user {
            font-size: 15px;
            @include sitellite_detail_white();
          }

          .product-site-title {
            display: flex;
            justify-content: space-between;
            align-items: flex-start;

            &-free {
              width: 50px;
              text-align: right;
            }
          }

          .product-site-detail {
            display: flex;
            justify-content: space-between;
            align-items: flex-end;

            .product-site-detail-right {
              width: 80px;
              height: 36px;
              border: 1px solid rgba(38, 125, 255, 1);
              color: rgba(38, 125, 255, 1);
              border-radius: 3px;
              cursor: pointer;
            }

            &-left {
              font-size: 15px;
              @include sitellite_detail_white();
            }
          }
        }

        .product-site-transparent {
          width: 360px;
        }
      }

      .pagenations {
        @include product_bg_r1_color();
        display: flex;
        justify-content: flex-end;
        padding-right: 0;
        padding: 20px 36px;
      }

      ::v-deep .btn-next {
        margin-right: 0;
      }

      ::v-deep .el-pagination {
        padding-right: 0;
      }
    }
  }
}

</style>